/**
 * HAWK AR MANAGER v1.1 (Fix)
 * - Eksik müşteri verisiyle AR oluşturma hatası giderildi (Dummy Data).
 * - API hata mesajları detaylandırıldı.
 */

class HawkARManager {
    constructor() {
        this.proxyUrl = 'https://api.hawkgaming.com.tr/api/proxy';
        this.uploadUrl = 'https://api.hawkgaming.com.tr/api/upload-image';
        this.lastOrderHash = null;
        
    }

    // -------------------------------------------------------
    // 1. ANA TETİKLEYİCİ
    // -------------------------------------------------------
    async handleARClick() {
        const isMobile = /iPhone|iPad|Android/i.test(navigator.userAgent);
        
        if (isMobile) {
            const modelViewer = document.getElementById("hawkgamingchair");
            if (modelViewer) {
                modelViewer.activateAR();
            }
        } else {
            await this.startDesktopARProcess();
        }
    }

    // -------------------------------------------------------
    // 2. MASAÜSTÜ SÜRECİ (Düzeltildi)
    // -------------------------------------------------------
    async startDesktopARProcess() {
        // KRİTİK DÜZELTME: Veriyi Hazırla (Boş alanları doldur)
        const currentData = this.prepareARData();
        const currentHash = JSON.stringify(currentData);

        if (this.lastOrderHash === currentHash) {
            document.getElementById("arQrContainer").style.display = "block";
            return;
        }

        this.lastOrderHash = currentHash;

        const qrContainer = document.getElementById("arQrContainer");
        qrContainer.style.display = "block";
        
        // Kullanıcıya bilgi ver (Opsiyonel görsel eklenebilir)
        // qrContainer.innerHTML = "AR Kodu Oluşturuluyor..."; 

        try {
            const response = await fetch(this.proxyUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    endpoint: '/order/create',
                    body: currentData
                })
            });

            const result = await response.json();

            if (result.result === true) {
                const orderNo = result.items.OrderNo;
                const link = `https://design.hawkchair.com/arsite.html?v=${orderNo}`;


                // Resimleri Yükle
                await this.uploadCustomImages(orderNo);

                // QR Kodu Üret
                this.generateQRCode(link);

            } else {
                alert(`AR Hatası: ${result.message || "Sipariş oluşturulamadı."}`);
                qrContainer.style.display = "none";
            }

        } catch (error) {
            alert("Sunucu ile bağlantı kurulamadı.");
            qrContainer.style.display = "none";
        }
    }

    // -------------------------------------------------------
    // YENİ: VERİ HAZIRLAMA (BOŞ ALANLARI DOLDURUR)
    // -------------------------------------------------------
    prepareARData() {
        // Global verinin kopyasını al
        let rawData = window.orderData;
        
        // Eğer StateManager kullanılıyorsa oradan al
        if (!rawData && window.hawkState && window.hawkState.orderData) {
            rawData = window.hawkState.orderData;
        }

        // Hiçbiri yoksa boş obje oluştur
        if (!rawData) rawData = {};

        const data = JSON.parse(JSON.stringify(rawData)); // Deep copy

        // Boş alanları "AR Misafiri" verileriyle doldur
        // (Çünkü API, İsim/Adres boş ise hata veriyor)
        
        const dummyInfo = {
            FirstName: "AR",
            LastName: "Preview",
            Email: "ar@hawkchair.com",
            Phone: "5555555555",
            Address: "Sanal Önizleme Adresi",
            Province: 34, // İstanbul ID (Tahmini)
            District: 1   // İlçe ID
        };

        if (!data.Delivery) data.Delivery = {};
        if (!data.Delivery.FirstName) Object.assign(data.Delivery, dummyInfo);

        if (!data.Customer) data.Customer = {};
        if (!data.Customer.FirstName) Object.assign(data.Customer, dummyInfo);
        if (!data.Customer.IPNumber) data.Customer.IPNumber = "127.0.0.1";

        if (!data.Invoice) data.Invoice = {};
        if (!data.Invoice.FirstName) Object.assign(data.Invoice, dummyInfo);
        if (!data.Invoice.Type) data.Invoice.Type = 0; // Bireysel

        // ProductID kontrolü
        if (!data.ProductID) data.ProductID = 8; // Varsayılan (Future Black)

        data.PaymentType = "iyzico";

        return data;
    }

    // -------------------------------------------------------
    // 3. RESİM YÜKLEME YÖNETİCİSİ
    // -------------------------------------------------------
    async uploadCustomImages(orderNo) {
        const tasks = [];

        if (window.onlogoyuklendi && window.resultonlogo && window.resultonlogo[0]) {
            tasks.push(this.sendPhotos(orderNo, "FrontLogo", window.resultonlogo[0]));
        }
        if (window.arkalogoyuklendi && window.resultarkalogo && window.resultarkalogo[0]) {
            tasks.push(this.sendPhotos(orderNo, "BackLogo", window.resultarkalogo[0]));
        }
        if (window.bellogoyuklendi && window.resultbellogo && window.resultbellogo[0]) {
            tasks.push(this.sendPhotos(orderNo, "WaistLogo", window.resultbellogo[0]));
        }
        if (window.yastiklogoyuklendi && window.resultyastiklogo && window.resultyastiklogo[0]) {
            tasks.push(this.sendPhotos(orderNo, "Nickname", window.resultyastiklogo[0]));
        }

        if (tasks.length > 0) {
            await Promise.all(tasks);
        }
    }

    // -------------------------------------------------------
    // 4. TEKİL RESİM GÖNDERİMİ
    // -------------------------------------------------------
    async sendPhotos(OrderNo, type, imageData) {
        const formdata = new FormData();
        let blob;
        let filename;

        if (imageData instanceof Blob) {
            blob = imageData;
            const ext = blob.type === "image/png" ? "png" : "webp";
            filename = `image.${ext}`;
        } else if (typeof imageData === "string" && imageData.startsWith("data:image/")) {
            const mimeMatch = imageData.match(/^data:(image\/(png|webp));base64,/);
            if (!mimeMatch) return;
            const mimeType = mimeMatch[1];
            const extension = mimeMatch[2];
            const base64 = imageData.replace(/^data:image\/(png|webp);base64,/, "");
            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            blob = new Blob([byteArray], { type: mimeType });
            filename = `image.${extension}`;
        } else {
            return;
        }

        formdata.append(type, blob, filename);

        try {
            await fetch(`${this.uploadUrl}?OrderNo=${OrderNo}&type=${type}`, {
                method: "POST",
                body: formdata,
                redirect: "follow"
            });
        } catch (error) {
            console.error(`${type} upload error:`, error);
        }
    }

    // -------------------------------------------------------
    // 5. QR KOD OLUŞTURUCU
    // -------------------------------------------------------
    generateQRCode(link) {
        const canvas = document.getElementById("qrCanvas");
        const qrLink = document.getElementById("arQrLink");

        if (qrLink) qrLink.href = link;

        if (canvas && typeof QRious !== 'undefined') {
            // Canvas'ı temizle (önceki QR'dan kalma olmasın)
            const ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            new QRious({
                element: canvas,
                value: link,
                size: 150,
                level: 'H'
            });
        }
    }

    closeQr() {
        const container = document.getElementById("arQrContainer");
        if (container) container.style.display = "none";
    }
}

window.hawkAR = new HawkARManager();